module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2zM14 7.12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2zm6 18c0 .552-.448.88-1 .88h-3c-1.106 0-2-.776-2-1.88V16h-1c-.552 0-1-.328-1-.88v-2c0-.554.448-1.12 1-1.12h3c1.106 0 2 1.014 2 2.12V22h1c.552 0 1 .566 1 1.12v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/info-1.js
// module id = 1190
// module chunks = 14